import { Value } from './abstract-value-accessor.model';
import { MONTH_NAMES } from './constants.model';

export enum Modes {
  month = 'month',
  year = 'year',
  mobile = 'mobile',
}

export type ModeTypes = 'month' | 'year' | 'mobile';

export interface IState {
  value: Value;
  mask: string;
  disabled: boolean;
  mode: ModeTypes;
  selected: Value;
  monthNames: string[];
  opened: boolean;
  title: string;
  resetButton: string;
  doneButton: string;
}

export const InitialState: IState = {
  value: null,
  mask: 'mm/yyyy',
  disabled: false,
  mode: Modes.month,
  selected: null,
  monthNames: MONTH_NAMES,
  opened: false,
  title: '',
  resetButton: 'Reset',
  doneButton: 'Done',
};
